import { useTranslation } from "react-i18next"
import { Result } from "antd"
import { Button } from "../../components/Button"
import { Link } from "../../components/Link"
import * as routes from "../../routes"

export const NotFound: React.FC = () => {
  const { t } = useTranslation()
  return (
    <Result
      status="404"
      title="Ups..."
      subTitle={t("pageNotFound.message")}
      extra={
        <Link to={routes.HOME}>
          <Button type="primary" label={t("pageNotFound.goHome")} />
        </Link>
      }
    />
  )
}
